//# sourceMappingURL=my-weekday.interface.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/mydatepicker/dist/interfaces/my-weekday.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-weekday.interface.js
// module chunks = 4